import {
  Breadcrumb,
  Button,
  Divider,
  Input,
  Layout,
  Result,
  Skeleton,
  theme
} from "antd";
import { Content } from "antd/es/layout/layout";
import { format } from "date-fns";
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { formatPrice } from "../../../../utils/format";
import "./DepositInfo.scss";
import {EyeOutlined} from "@ant-design/icons";
import {apiDepositDetail} from "../../../../api/deposits";
import {bankOptions} from "../../../../utils/bankList";
import DepositTransactionsList from "./DepositTransactionsList/DepositTransactionsList";
import DepositSellersSummary from "./DepositSellersSummary/DepositSellersSummary";
import DepositEntriesList from "./DepositEntriesList/DepositEntriesList";

const DepositInfo = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const pathname = window.location.pathname;
  const parts = pathname.split("/");
  const depositID = parts[parts.length - 1];

  const [dataTransaction, setDataTransaction] = useState();
  const [loading, setLoading] = useState(false);
  const [activeError, setActiveError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");
  const navigate = useNavigate();

  const dateObject = dataTransaction && new Date(dataTransaction?.created_at);
  const dateFormated =
    dataTransaction && format(dateObject, "dd/MM/yyyy 'às' HH:mm:ss");

  const renderError = (status) => {
    if (activeError) {
      return (
        <Result
          status={status === "500" ? "500" : "404"}
          title={status}
          subTitle={
            status === "500"
              ? "Ocorreu um erro no servidor, tente novamente mais tarde."
              : "Ocorreu um erro, tente novamente mais tarde."
          }
          extra={
            <Button onClick={() => navigate("/listagem-depositos")} type="primary">
              Listagem de depósitos
            </Button>
          }
        />
      );
    }
  };
  const handleList = useCallback(async () => {
    setLoading(true);
    try {
      const json = await apiDepositDetail(depositID);
      setDataTransaction(json);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setActiveError(true);
      if (error.status === 400 || error.status === 404) {
        setErrorStatus("404");
      } else if (error.status === 500) {
        setErrorStatus("500");
      } else {
        setErrorStatus("404");
      }
    }
  }, [depositID]);

  useEffect(() => {
    handleList();
  }, [handleList]);

  const statusName = {
    confirmed: "Confirmada",
    succeeded: "Sucesso",
    created: "Criada",
    pending: "Pendente",
    canceled: "Cancelada",
    failed: "Falhou",
  };

  const renderStatusName = (status, obj) => {
    if (status === "succeeded" && obj?.confirmed) {
      status = "confirmed"
    }
    return statusName[status] || "Indefinido";
  }

  const statusMap = {
    confirmed: <span className="badge badge-success">Confirmada</span>,
    succeeded: <span className="badge badge-success">Sucesso</span>,
    created: <span className="badge yellow">Criada</span>,
    pending: <span className="badge yellow">Pendente</span>,
    canceled: <span className="badge badge-error">Cancelada</span>,
    failed: <span className="badge badge-error">Falhou</span>,
  };

  const renderStatus = (status, obj) => {
    if (status === "succeeded" && obj?.confirmed) {
      status = "confirmed"
    }
    return statusMap[status] || <span className="badge black">Indefinido</span>;
  };

  const typeName = {
    payout: "Depósito",
    payout_automatic: "Depósito automático",
  };

  const renderTypeName = (status) => {
    return typeName[status] || "Desconhecido";
  }

  const accountTypeName = {
    checking: "Corrente",
    savings: "Poupança",
    payment: "Pagamento",
  };

  const renderAccountTypeName = (status) => {
    return accountTypeName[status?.toLowerCase()] || "Desconhecido";
  }

  const getTaxPayerType = () => {
    if (dataTransaction?.destination?.taxpayer_id.length === 14) {
      return "CNPJ"
    }
    return "CPF"
  }

  const formatTaxPayerId = () => {
    if (dataTransaction?.destination?.taxpayer_id.length === 14) {
      return dataTransaction?.destination?.taxpayer_id.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
    }
    return dataTransaction?.destination?.taxpayer_id.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
  }

  return (
    <div className="DepositInfo">
      <Layout
        style={{
          padding: "1.25rem",
        }}
      >
        {errorStatus ? (
          renderError()
        ) : (
          <>
            <Breadcrumb
              style={{
                margin: "16px 0",
              }}
            >
              {loading ? <Skeleton active paragraph={{ rows: 0 }} /> :
                <h2 className="title-page">
                  {formatPrice(dataTransaction?.amount)}
                </h2>
              }
              <Divider />
              {loading ? <Skeleton active paragraph={{ rows: 0 }} /> :
                <>
                  <Breadcrumb.Item>
                    {formatPrice(dataTransaction?.amount)}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>Depósito #{dataTransaction?.id}</Breadcrumb.Item>
                </>
              }
            </Breadcrumb>
            <Content
              style={{
                padding: 24,
                margin: 0,
                minHeight: 280,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
              }}
            >
              {loading ? <Skeleton active paragraph={{ rows: 1 }} /> :
                <div className="container-subtitle">
                  <h3 className="subtitle-page">Informações do depósito</h3>
                  {renderStatus(dataTransaction?.status, dataTransaction)}
                </div>
              }
              <Divider />
              {loading ? <Skeleton active paragraph={{ rows: 3 }} /> :
                <div className="container-inputs">
                  <div className="container-left">
                    <div>
                      <p>Data/hora da criação</p>
                      <Input disabled value={dateFormated} />
                    </div>
                    <div>
                      <p>Valor líquido</p>
                      <Input
                        disabled
                        value={formatPrice(dataTransaction?.amount)}
                      />
                    </div>
                    <div>
                      <p>Status</p>
                      <Input
                        disabled
                        value={renderStatusName(dataTransaction?.status, dataTransaction)}
                      />
                    </div>
                    <div>
                      <p>Descrição</p>
                      <Input
                          disabled
                          value={dataTransaction?.description}
                      />
                    </div>
                  </div>
                  <div className="container-right">
                    <div>
                      <p>Natureza da operação</p>
                      <Input
                        disabled
                        value={renderTypeName(dataTransaction?.type)}
                      />
                    </div>
                    <div>
                      <p>Código de confirmação</p>
                      <Input
                        disabled
                        value={
                          dataTransaction?.transfer_number
                        }
                      />
                    </div>
                    <div>
                      <p>Referência</p>
                      <Input
                          disabled
                          value={
                            dataTransaction?.id
                          }
                      />
                    </div>
                  </div>
                </div>
              }
            </Content>
            {!loading && (
              <>

                <Content
                  style={{
                    padding: 24,
                    margin: "30px 0 0 0",
                    minHeight: dataTransaction?.customer ? 280 : 40,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                  }}
                >
                  <div className="container-subtitle">
                    <h3 className="subtitle-page">Informações do remetente</h3>
                  </div>
                  <Divider />
                  <div className="container-inputs">
                    <div className="container-left">
                      <div>
                        <p>Originador</p>
                        <div className='input-container'>
                          <Input disabled value={dataTransaction?.account?.display_name} />
                          <EyeOutlined
                            onClick={() => window.open(`/lojista/detalhes/${dataTransaction.account.id}`, "_blank")}
                            className='eye-icon'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Content>

                <Content
                  style={{
                    padding: 24,
                    margin: "30px 0 0 0",
                    minHeight: 280,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                  }}
                >
                  <div className="container-subtitle">
                    <h3 className="subtitle-page">Conta Destino</h3>
                  </div>
                  <Divider />
                  <div className="container-inputs">
                    <div className="container-left">
                      <div>
                        <p>{getTaxPayerType()}</p>
                        <Input
                            disabled
                            value={
                              formatTaxPayerId()
                            }
                        />
                      </div>
                      <div>
                        <p>Agência</p>
                        <Input
                            disabled
                            value={
                              dataTransaction?.destination?.agency
                            }
                        />
                      </div>
                      <div>
                        <p>Tipo de Conta</p>
                        <Input
                            disabled
                            value={
                              renderAccountTypeName(dataTransaction?.destination?.type)
                            }
                        />
                      </div>
                    </div>
                    <div className="container-right">
                      <div>
                        <p>Conta</p>
                        <Input
                            disabled
                            value={
                              dataTransaction?.destination?.number
                            }
                        />
                      </div>
                      <div>
                        <p>Instituição</p>
                        <Input
                            disabled
                            value={
                              bankOptions.filter(bank => bank.value === dataTransaction?.destination?.code)[0]?.label
                            }
                        />
                      </div>
                    </div>
                  </div>
                </Content>

                <Content
                  style={{
                    padding: 24,
                    margin: "30px 0 0 0",
                    minHeight: 280,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                  }}
                >
                  <div className="container-subtitle">
                    <h3 className="subtitle-page">Resumo dos vendedores</h3>
                  </div>
                  <Divider />
                  <div className="container-table">
                    <DepositSellersSummary depositId={dataTransaction?.id} />
                  </div>
                </Content>

                <Content
                  style={{
                    padding: 24,
                    margin: "30px 0 0 0",
                    minHeight: 280,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                  }}
                >
                  <div className="container-subtitle">
                    <h3 className="subtitle-page">Transações relacionadas</h3>
                  </div>
                  <Divider />
                  <div className="container-table">
                    <DepositTransactionsList depositId={dataTransaction?.id} />
                  </div>
                </Content>

                <Content
                  style={{
                    padding: 24,
                    margin: "30px 0 0 0",
                    minHeight: 280,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                  }}
                >
                  <div className="container-subtitle">
                    <h3 className="subtitle-page">Outros lançamentos</h3>
                  </div>
                  <Divider />
                  <div className="container-table">
                    <DepositEntriesList depositId={dataTransaction?.id} />
                  </div>
                </Content>
              </>
            )}
          </>
        )}
      </Layout>
    </div>
  );
};

export default DepositInfo;
